import styled, { css } from 'styled-components';
import { elevationTransition, elevation } from '../Styles/Utils/elevation.js';

const Container = styled.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-2946b8e-0"
})`
    padding: 16px;
    background-color: ${(props)=>props.theme.colors.Background};
    border: 2px solid ${(props)=>props.borderColor || props.theme.colors["Level 1"]};
    border-radius: 8px;
    ${elevationTransition}
    color: ${(props)=>props.theme.colors.Foreground};

    ${(props)=>!props.highlight && props.defaultHover && css`
            cursor: pointer;
            &:hover {
                background-color: ${props.theme.colors.ElementBackground};
                ${elevation(1, true)}
            }
        `}

    ${(props)=>!props.highlight && props.elevated && css`
            background-color: ${props.theme.colors.ElementBackground};
            ${elevation(1, true)}
        `}

    ${(props)=>props.highlight && css`
            background-color: ${props.theme.colors["Level 1"]};
            transition: all 0.3s ease;
            border-color: transparent;
        `}
`;

export { Container };
